import ambassadors from "./ambassadors"
import signUp from "./sign-up"
import signIn from "./sign-in"
import home from "./home"
import installer from "./installer"
import blog from "./blog"
import common from "./common"
import guides from "./guides"
import dynamicForms from "./dynamic-forms"
import metaTags from "./meta-tags"
import about from "./about"
import dialogs from "@common/js/translations/fr/dialogs"
import enedisMandate from "@common/js/translations/fr/enedis-mandate"
import footer from "./footer"
import hardwareMarketplace from "./hardware-marketplace"
import career from "./career"
import help from "./help"
import support from "./support"
import resaleAgreements from "./resale-agreements"

export default {
  ambassadors,
  guides,
  dialogs,
  "meta-tags": metaTags,
  "enedis-mandate": enedisMandate,
  navigation: {
    blog: "Ressources",
    installers: "professionnels",
    installersDropdown: "Professionnels",
    help: "Centre d'aide",
    "about-us": "Nous connaître",
    "sign-in": "Connexion",
    "sign-up": "Inscription",
    documentation: "Documentation",
    installer: "Professionnels",
    "digital-sales": "Études",
    administration: "Gestion administrative",
    "find-new-clients": "Mise en relation",
    sizing: "Dimensionnement",
  },

  footer,

  "reset-password": {
    title: "Récupérer son mot de passe",
    subtitle:
      "Entrez l'email que vous avez utilisée lors de votre inscription, et nous vous enverrons un email automatique de réinitialisation du mot de passe.",
    "check-your-inbox": "vérifiez votre boîte de réception",
    type: {
      householder: "Propriétaire",
      installer: "Professionnel",
    },
    success: {
      title: "Vérifiez votre boîte email de réception.",
      description:
        "Si vous n'avez pas reçu d'email, veuillez vérifier votre courriel indésirable.",
    },
    callback: {
      title: "Réinitialiser votre mot de passe",
      "description-1":
        "« Pour protéger vos informations, il est nécessaire de choisir et d’utiliser des mots de passe robustes, c’est-à-dire difficiles à retrouver à l’aide d’outils automatisés et à deviner par une tierce personne »",
      "description-2": "www.interieur.gouv.fr",
      anssi: "l’Agence Nationale de la Sécurité des Systèmes d’Information",
      password: "Mot de passe",
      "confirm-password": "Confirmation du mot de passe",
      "reset-your-password": "Réinitialiser votre mot de passe",
      errors: {
        "no-token-present": "Le lien de réinitialisation est invalide",
        "token-expired": "Le lien de réinitialisation a expiré",
        "token-invalid": "Le lien de réinitialisation est invalide",
      },
      "resend-link":
        "Renvoyer un lien de réinitialisation de mot de passe par email",
    },
    "forgot-password": {
      title: "Mot de passe oublié ?",
      description:
        "Entrez l'e-mail que vous avez utilisée lors de votre inscription de votre compte, et nous vous enverrons l'email de réinitialisation sécurisée du mot de passe.",
      "select-type": "Vous êtes ...",
      email: "Email",
      "reset-your-password": "Réinitialiser votre mot de passe",
    },
  },

  "sign-in": signIn,
  "sign-up": signUp,

  home,
  installer,
  blog,

  about,

  "dynamic-forms": dynamicForms,

  support,
  help,
  "learn-centre": {
    header: {
      title: "Tout savoir sur le solaire",
    },
  },

  career,

  profile: {
    dropdown: {
      tickets: "Me tickets",
      settings: "Paramètres",
      "sign-out": "Déconnexion",
      type: {
        householder: "Propriétaire",
        installer: "Professionnel",
        admin: "Admin",
      },
    },
  },

  common,

  snackbars: {
    "lead-submitted": "Nous avons reçu votre demande",
    "password-reset-success": "Mot de passe mis à jour.",
    "reset-token-sent":
      "Vérifiez votre email pour mettre à jour votre mot de passe.",
    "register-success":
      "Vous avez créé votre compte projetsolaire ! Confirmez votre inscription avec le courriel dans votre boîte mail.",
    "login-success": "Bienvenue sur projetsolaire",
    "account-activated": "Votre compte a été activé avec succès.",
    success: {
      title: "Succès",
      common: "Informations sauvegardées avec succès",
    },
    errors: {
      title: "Alerte !",
      common:
        "Une erreur s’est produite. Veuillez réessayer puis nous contacter si le problème persiste.",
      failed:
        "Une erreur s’est produite. Veuillez réessayer puis nous contacter si le problème persiste.",
      "password-reset-failed": "La mise à jour du mot de passe a échouée.",
      "login-failed": "Connexion échouée : vérifier votre saisie.",
      "register-failed":
        "Nous n’avons pas pu créer votre compte. Veuillez réessayer puis nous contacter si le problème persiste.",
    },
  },
  "resale-agreements": resaleAgreements,
  "hardware-marketplace": hardwareMarketplace,
}
